var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.misaNotifyV2Enabled)?_c('div',{attrs:{"id":"misa-notif-top-slot"}}):_vm._e(),_c('router-view'),_c('div',{attrs:{"id":"message-box"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }